<template>
  <div>
    <v-row>
      <v-col cols="12" lg="12">
        <!-- <SumarryReports isActive="activated"></SumarryReports> -->
      </v-col>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    OLT List
                  </v-toolbar-title>
                </div>
                <div class="ml-auto">
                  <v-btn color="primary" @click="addOlt()">
                    <v-icon class="mr-2">mdi-plus</v-icon> Add
                  </v-btn>
                  <!-- <v-btn color="primary" class="ml-2" @click="goBack()">
                  <v-icon class="mr-2">mdi-plus</v-icon> Add Serial
                </v-btn> -->
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
            v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              @click:append="searchRecord"
              @keydown.enter.prevent="searchRecord"
              @click:clear="getList()"
              clearable
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :page="table.page"
            :pageCount="table.numberOfPages"
            :options.sync="options"
            :server-items-length="table.total"
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="_id"
            loading-text="Loading... Please wait"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [10, 20, 50, 100],
            }"
            dense
          >
            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <template v-slot:[`item.brandId`]="{ item }">
              {{ filterBrands(item.brandId)[0].name }}
            </template>

            <template v-slot:[`item.modelId`]="{ item }">
              {{ filterModels(item.modelId)[0].name }}
            </template>

            <template v-slot:[`item.configured`]="{ item }">
              <!-- {{ item.configured ? "Yes" : "No" }} -->
              <div class="d-flex justify-center">
                <v-switch
                  :input-value="item.configured"
                  flat
                  @change="updateConfigure($event, item)"
                ></v-switch>
              </div>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <!-- <a @click="viewDrawDetail(item)">{{ item.name }}</a> -->
              <v-btn x-small color="primary" dark @click="syncOlt(item)">
                Sync</v-btn
              >
              <v-btn
                x-small
                color="primary"
                dark
                @click="testOlt(item)"
                class="ml-2"
              >
                Test</v-btn
              >
              <v-btn
                x-small
                color="warning"
                class="ml-2"
                dark
                @click="editOlt(item)"
              >
                Edit</v-btn
              >
              <v-btn
                x-small
                color="error"
                class="ml-2"
                dark
                @click="deleteOlt(item)"
              >
                Delete</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <EditOltDialog
      :dialog="editOltDialog.dialog"
      :data="editOltDialog.data"
      :actionType="editOltDialog.type"
      @response="editOltDialogResponse"
      @close="editOltDialog.dialog = !editOltDialog.dialog"
    >
    </EditOltDialog>
    <Snackbar></Snackbar>
    <ConfirmationDiaglog
      :dialog="confirmationDialog.dialog"
      :message="confirmationDialog.message"
      :title="confirmationDialog.title"
      @response="confirmationDialogResponse"
    ></ConfirmationDiaglog>

    <v-dialog
      v-model="test.dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <v-card>
        <!-- <v-card-title class="text-h5">
          Result
        </v-card-title> -->

        <v-toolbar dark color="primary">
          <v-toolbar-title>Result</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeTest()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <!-- Are you sure you want to delete this message? -->
          <div class="textResult" v-html="test.message"></div>
          <!-- {{ message }} -->
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeTest()"> Close </v-btn>
          <!-- <v-btn color="primary" @click="actionResponse(true)">
            Yes
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import EditOltDialog from "../dialogs/management/EditOltDialog.vue";
import Snackbar from "../dialogs/Snackbar.vue";
import ConfirmationDiaglog from "../dialogs/ConfirmationDiaglog.vue";
// import axios from "axios";
export default {
  name: "OltList",
  components: {
    EditOltDialog,
    Snackbar,
    ConfirmationDiaglog,
  },
  data() {
    return {
      switch1: false,
      confirmationDialog: {
        dialog: false,
        title: "",
        message: "",
      },

      editOltDialog: {
        dialog: false,
        data: null,
        type: "ADD",
      },

      test: {
        dialog: false,
        message: "",
      },

      dataTobeDeleted: {},
      search: "",
      table: {
        page: 0,
        total: 0,
        numberOfPages: 0,

        expanded: [],
        singleExpand: false,
        sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        // oltName, oltIp, version, type, vlan, config
        headers: [
          {
            text: "OLT Name",
            sortable: false,
            value: "oltName",
          },
          { text: "OLT IP", value: "oltIp" },
          { text: "Version", value: "version" },
          {
            text: "Type",
            value: "type",
            // formatter: (x) =>
            //   x ? moment(x).format("MMM DD, YYYY h:mm:ss A") : null,
          },
          { text: "VLan", value: "vlan" },
          { text: "Config", value: "config" },
          {
            text: "Date/Time Created",
            value: "createdDate",
            formatter: (x) =>
              x ? moment(x).format("MMM DD, YYYY h:mm:ss A") : null,
          },
          { text: "Configured", align: "center", value: "configured" },
          { text: "Actions", value: "actions", align: "center", width: "35%" },
        ],
        data: [],
      },
      options: {
        page: 1,
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    searchRecord() {
      this.options.page = 1;
      if (!this.search) {
        return;
      }

      this.getList(this.search);
    },

    async getList(searchVal = "") {
      this.table.loading = true;
      const { page, itemsPerPage } = this.options;
      let pageNumber = "";
      if (itemsPerPage === -1) {
        pageNumber = "";
      } else {
        pageNumber = page ? page : 1;
      }

      const perPage = itemsPerPage < 0 ? "" : itemsPerPage;

      await this.$api
        .get(`/olt-list?page=${pageNumber}&limit=${perPage}&searchVal=${searchVal}`)
        .then((response) => {
          const newArr = response.data.data;

          // console.log(newArr);
          this.table.data = newArr.oltList;
          this.table.total = newArr.total;
          this.table.numberOfPages = Math.ceil(newArr.total / itemsPerPage);
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    editOlt(data) {
      this.editOltDialog.type = "EDIT";
      this.editOltDialog.dialog = true;
      this.editOltDialog.data = data;
    },

    addOlt() {
      this.editOltDialog.type = "ADD";
      this.editOltDialog.dialog = true;
      // this.editOltDialog.data = data;
    },

    editOltDialogResponse(e) {
      // console.log(e.message);
      if (e.status) {
        this.getList();
      }

      // this.snachbar.message = e.message;
      this.$store.dispatch("addSnackbarMessage", e.message);
      this.$store.dispatch("addSnackbar", true);
      this.editOltDialog.dialog = false;
    },

    deleteOlt(data) {
      // console.log(data);
      this.confirmationDialog.dialog = true;
      this.confirmationDialog.title = "Confirmation";
      this.confirmationDialog.message = "Are you sure you want to delete";
      this.dataTobeDeleted = data;
    },

    confirmationDialogResponse(e) {
      if (!e) {
        this.confirmationDialog.dialog = false;
        this.confirmationDialog.title = "";
        this.confirmationDialog.message = "";
        return;
      }

      this.deleteOltAction();
    },

    async deleteOltAction() {
      const { _id } = this.dataTobeDeleted;

      // confirmationDialogResponse

      this.table.loading = true;
      await this.$api
        .delete("/olt-list", {
          data: {
            _id: _id,
          },
        })
        .then((response) => {
          // const newArr = response.data.data.oltList;
          console.log(response);
          const res = response.data;

          if (res.status) {
            this.confirmationDialog.dialog = false;
            this.confirmationDialog.title = "";
            this.confirmationDialog.message = "";
            this.$store.dispatch("addSnackbarMessage", "Successfully deleted.");
            this.$store.dispatch("addSnackbar", true);
            this.getList();
          }
          // this.table.data = newArr;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    async updateConfigure(e, item) {
      const payload = {
        configured: e,
        _id: item._id,
        // location: item.location,
        // oltName: item.oltName,
        // oltIp: item.oltIp,
        // version: item.version,
        // type: item.type,
        // vlan: item.vlan,
        // config: item.config,
      };
      await this.$api
        .put("olt-list", payload)
        .then(() => {})
        .catch((e) => {
          console.log(e);
        });
    },

    async syncOlt(item) {
      this.table.loading = true;
      await this.$api
        .post(`/sync-olt`, { oltName: item.oltName })
        .then((response) => {
          // const newArr = response.data.data.oltList;
          this.test.dialog = true;
          this.test.message = response.data;
          // console.log(response.data);
          // this.table.data = newArr;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    async testOlt(item) {
      this.table.loading = true;
      await this.$api
        .get(`/tools/check-vlan?oltName=${item.oltName}`, {
          responseType: "text",
        })
        .then((response) => {
          // const newArr = response.data.data.oltList;
          this.test.dialog = true;
          this.test.message = response.data;
          // console.log(response.data);
          // this.table.data = newArr;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    closeTest() {
      this.test.dialog = false;
      this.test.message = "";
    },
  },
  created() {
    // this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    options: {
      handler() {
        this.getList(this.search);
      },
      deep: true,
    },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>

<style scoped>
.p-0 {
  padding: 0px !important;
}

.sub-areas > div > table > thead > tr {
  background-color: red;
  border-radius: 10px;
}
</style>

<style>
.textResult > table {
  /* border: 1px solid black !important; */
  border-collapse: collapse !important;
  margin: 50px 0px;
  width: 100%;
}

.textResult > table,
th,
td {
  border-collapse: collapse !important;
  padding: 10px 40px;
}
</style>
